import { QGLResponse } from "./types";
import { api } from "./index";
import { userFragment } from "./fragments";
import { IAPData, UserModel } from "../lib/models";
import { getPlatform, PLATFORMS } from "../lib/utils";

export const addToWatchListMutation = `
	mutation AddToWatchList($contentId: String!, $contentType: String) {
	  addToWatchList(contentId: $contentId, contentType: $contentType) {
		id
		__typename
	  }
	}
`;

export const removeFromWatchListMutation = `
	mutation RemoveWatchList($contentId: String!, $contentType: String) {
	  removeFromWatchList(contentId: $contentId, contentType: $contentType) {
		id
		__typename
	  }
	}
`;

export const updateProgressMutation = `
    mutation UpdateProgress($id: String!, $progress: Int!, $contentType: String) {
      updateProgress(contentId: $id, progress: $progress, contentType: $contentType) {
        ...on Episode {
          id
          title
          progress {
            current
          }
        }
      }
    }
`;

const amazonSubscriptionMutation = `
mutation CreateFireTvSubscription($userId: String!, $receiptId: String!){
    createFireTvSubscription(userId: $userId, receiptId: $receiptId) {
        ...UserData
    }
}`;

const androidSubscriptionMutation = `
mutation CreateAndroidTvSubscription($purchaseToken: String!, $subscriptionId: String!){
    createAndroidTvSubscription(purchaseToken: $purchaseToken, subscriptionId: $subscriptionId) {
        ...UserData
    }
}`;

export const addToWatchList = async (id: string | number, type?: string) => {
    const { data }: QGLResponse = await api("graphql", {
        method: "POST",
        body: { query: addToWatchListMutation, variables: { contentId: id, contentType: type } }
    });

    return data;
};

export const removeFromWatchList = async (id: string | number, type?: string) => {
    const { data }: QGLResponse = await api("graphql", {
        method: "POST",
        body: { query: removeFromWatchListMutation, variables: { contentId: id, contentType: type } }
    });

    return data;
};

export const updateProgress = async (id: string | number, progress: number, contentType?: string) => {
    const { data }: QGLResponse = await api("graphql", {
        method: "POST",
        body: { query: updateProgressMutation, variables: { id: id, progress: progress, contentType } }
    });

    return data;
};

export const createPostTvSubscription = async (priceId?: string) => {
    const { data }: QGLResponse = await api("graphql", {
        method: "POST",
        body: {
            query: `
                mutation CreateSub($priceId: String){
                  createSubscription(priceId: $priceId){
                     ...UserData
                  }
                },
                ${userFragment}
        `,
            variables: { priceId }
        }
    });

    return data.createSubscription;
};

export const getPayAlteoxSubscriptionLink = async (body?: any) => {
    const { data }: QGLResponse = await api("graphql", {
        method: "POST",
        body: {
            query: `
                mutation SubscriptionLink($action: String, $transactionId: String, $amazonUserId: String, $subscriptionId: String){
                  getSubscriptionLink(action: $action, transactionId: $transactionId, amazonUserId: $amazonUserId, subscriptionId: $subscriptionId){
                    url,
                    otp
                  }
                }
        `,
            variables: body
        }
    });

    return data.getSubscriptionLink;
};

export const login = async ({
    ...body
}: {
    email: string;
    password: string;
    transactionId?: string;
    amazonUserId?: string;
    subscriptionId?: string;
}) => {
    const { data, errors }: QGLResponse = await api("graphql", {
        method: "POST",
        body: {
            query: `
                mutation Login($email: String!, $password: String!, $transactionId: String, $amazonUserId: String, $subscriptionId: String){
                  loginByPassword(email: $email, password: $password, transactionId: $transactionId, amazonUserId: $amazonUserId, subscriptionId: $subscriptionId){
                     ...UserData
                  }
                },
                ${userFragment}
        `,
            variables: body
        }
    });

    console.log(
        `login response ${JSON.stringify({
            data,
            errors
        })}`
    );

    return {
        data: data?.loginByPassword,
        error: errors ? errors[0] : null
    };
};

export const signup = async (body: {
    email: string;
    password: string;
    name: string;
    transactionId?: string;
    amazonUserId?: string;
    subscriptionId?: string;
}) => {
    const { data, errors }: QGLResponse = await api("graphql", {
        method: "POST",
        body: {
            query: `
                mutation Signup($email: String!, $password: String!, $name: String!, $transactionId: String, $amazonUserId: String, $subscriptionId: String){
                  signupByPassword(email: $email, password: $password, name: $name, transactionId: $transactionId, amazonUserId: $amazonUserId, subscriptionId: $subscriptionId){
                     ...UserData
                  }
                },
                ${userFragment}
        `,
            variables: body
        }
    });

    console.log(
        `signup response ${JSON.stringify({
            data,
            errors
        })}`
    );

    return {
        data: data?.signupByPassword,
        error: errors ? errors[0] : null
    };
};

export const logout = async () => {
    const { data }: QGLResponse = await api("graphql", {
        method: "POST",
        body: {
            query: `
                mutation Logout{
                  logout{
                     ...UserData
                  }
                },
                ${userFragment}
        `
        }
    });

    return data.logout;
};

export const syncExternalSubscription = async (body: IAPData): Promise<UserModel> => {
    console.log(`body: ${JSON.stringify(body)}`);
    console.log(`query: ${(await getPlatform()) === PLATFORMS.androidtv ? androidSubscriptionMutation : amazonSubscriptionMutation},
                ${userFragment}`);

    const { data, errors }: QGLResponse = await api("graphql", {
        method: "POST",
        body: {
            query: `
                ${(await getPlatform()) === PLATFORMS.androidtv ? androidSubscriptionMutation : amazonSubscriptionMutation},
                ${userFragment}
        `,
            variables: body
        }
    });

    console.log(
        `response ${JSON.stringify({
            errors,
            data
        })}`
    );

    if (errors) {
        throw errors;
    }

    return data.createAndroidTvSubscription || data.createFireTvSubscription;
};

export const verifyParentalPinMutation = `
  mutation VerifyParentalPin($pin: String!) {
    verifyParentalPin(pin: $pin)
  }
`;

export const updateParentalPinMutation = `
  mutation UpdateParentalPin($pin: String!, $ageRestriction: String) {
    updateParentalPin(pin: $pin, ageRestriction: $ageRestriction) {
      ...UserData
    }
  }
  ${userFragment}
`;

export const removeParentalPinMutation = `
  mutation RemoveParentalPin {
    removeParentalPin {
      ...UserData
    }
  }
  ${userFragment}
`;

export const verifyParentalPin = async (pin: string): Promise<boolean> => {
  try {
    const { data, errors }: QGLResponse = await api("graphql", {
      method: "POST",
      body: {
        query: verifyParentalPinMutation,
        variables: { pin }
      }
    });
    
    if (errors) {
      console.error("[verifyParentalPin] GraphQL errors:", errors);
      throw new Error(errors[0]?.message || "Failed to verify parental PIN");
    }
    
    return data?.verifyParentalPin ?? false;
  } catch (error) {
    console.error("[verifyParentalPin] Error:", error);
    throw error;
  }
};

export const updateParentalPin = async (pin: string, ageRestriction?: string): Promise<UserModel> => {
  try {
    console.log("[updateParentalPin] Calling mutation with:", { pin, ageRestriction });
    console.log("[updateParentalPin] Mutation query:", updateParentalPinMutation);
    
    const response: QGLResponse = await api("graphql", {
      method: "POST",
      body: {
        query: updateParentalPinMutation,
        variables: { pin, ageRestriction }
      }
    });
    
    console.log("[updateParentalPin] Response:", response);
    
    if ('errors' in response && response.errors) {
      console.error("[updateParentalPin] GraphQL errors:", response.errors);
      const errorMessage = response.errors[0]?.message || "Failed to update parental PIN";
      throw new Error(errorMessage);
    }
    
    if ('data' in response && response.data) {
      if (!response.data.updateParentalPin) {
        console.error("[updateParentalPin] No updateParentalPin in data:", response.data);
        throw new Error("No data returned from updateParentalPin mutation");
      }
      return response.data.updateParentalPin;
    }
    
    throw new Error("Unexpected response format");
  } catch (error) {
    console.error("[updateParentalPin] Error:", error);
    throw error;
  }
};

export const updateAgeRestrictionMutation = `
  mutation UpdateAgeRestriction($ageRestriction: String!) {
    updateAgeRestriction(ageRestriction: $ageRestriction) {
      ...UserData
    }
  }
  ${userFragment}
`;

// Persists ONLY the age restriction for the authenticated user — no parental PIN
// required (age is our own setting, decoupled from the box PIN).
export const updateAgeRestriction = async (ageRestriction: string): Promise<UserModel> => {
  try {
    const response: QGLResponse = await api("graphql", {
      method: "POST",
      body: {
        query: updateAgeRestrictionMutation,
        variables: { ageRestriction }
      }
    });

    if ('errors' in response && response.errors) {
      console.error("[updateAgeRestriction] GraphQL errors:", response.errors);
      throw new Error(response.errors[0]?.message || "Failed to update age restriction");
    }

    if ('data' in response && response.data) {
      if (!response.data.updateAgeRestriction) {
        throw new Error("No data returned from updateAgeRestriction mutation");
      }
      return response.data.updateAgeRestriction;
    }

    throw new Error("Unexpected response format");
  } catch (error) {
    console.error("[updateAgeRestriction] Error:", error);
    throw error;
  }
};

export const removeParentalPin = async (): Promise<UserModel> => {
  try {
    const { data, errors }: QGLResponse = await api("graphql", {
      method: "POST",
      body: {
        query: removeParentalPinMutation,
        variables: {}
      }
    });
    
    if (errors) {
      console.error("[removeParentalPin] GraphQL errors:", errors);
      throw new Error(errors[0]?.message || "Failed to remove parental PIN");
    }
    
    if (!data?.removeParentalPin) {
      console.error("[removeParentalPin] No data returned:", data);
      throw new Error("No data returned from removeParentalPin mutation");
    }
    
    return data.removeParentalPin;
  } catch (error) {
    console.error("[removeParentalPin] Error:", error);
    throw error;
  }
};
